<template>
	<div>

	</div>
</template>

<style>
</style>

<script>
import { mapGetters } from "vuex";

// doRendering is a store property that controls wether the scene gets rendered
// We can add features to stop rendering here e.g. if the user doesnt move 
export default {
    data: () => ({
   
    }),
    computed: {
        ...mapGetters(['isDialogueOpen']),
    },
    methods:{
  
    },
    watch: {
        // isDialogueOpen is a store property that is true if a dialogue is open (e.g. MapDialogue, LoginDialogue, ShareDialogie)
        // if a dialogue is open we dont want the scene to get rendered
        isDialogueOpen: function(){
            this.$store.commit('doRendering',!this.isDialogueOpen);
        }
    },
    mounted: function(){
        
    }
}
</script>